import { Component, Inject, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormControl, NgForm } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastSuccessfullyComponent } from 'src/app/modules/shared/toast/toast-successfully.component';
import { HelperService } from 'src/app/modules/core';
import { CreateOrUpdateSimulations, SimulationDialog as SimulationDialogData } from '../../types';
import { DateAdapter } from '@angular/material/core';
import { ConfirmCloseDialogComponent, OrganizationService } from 'src/app/modules/shared';
import { SimulationService } from '../../services';
import { TranslateService } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import { ValidationService } from 'src/app/modules/core/services/validation.service';
import { AuthService } from 'src/app/modules/core/auth/services/auth.service';

@Component({
    selector: 'add-simulation-form-app',
    templateUrl: 'add-simulation-form.component.html',
    styleUrls: ['./add-simulation-form.component.scss'],
})
export class AddSimulationFormComponent {
    dateOfSimulation: Date;
    actionType = 'create';
    createOrUpdateModel: CreateOrUpdateSimulations = {
        simulationId: 0,
        actionType: '',
        detailsRequest: {
            name: '',
            startDate: 0,
            startTime: '',
            organizationId: '',
            simulationTypeId: '',
            roomNumber: '',
            participantLogAvailable: 1,
        },
        settingsRequest: {
            loginCode: '',
            link: '',
            acceptJoinViaLink: true,
            allowJoinAfterSimulationStarts: false,
            startVideoRecording: false,
            invitePeople: [],
            resendEmail: true,
        },
    };

    listOrganization: any[];
    activeTab = 1;
    lstTab = [1];
    activeAm = true;
    activePm = false;
    minute = '00';
    second = '00';
    listSimulationType: any[];
    // listSimulationTypeSelected: any[];
    separatorKeysCodes: number[] = [ENTER, COMMA];
    peopleCtrl = new FormControl('');
    inviteLink: string = '';
    validateTime: boolean = false;
    inputTime = ''

    @ViewChild('myForm') myFormElement: NgForm;
    // @ViewChild('simulationTypeCtrl') simulationTypeCtrl: NgForm;
    @ViewChild('peopleInput') peopleInput: ElementRef<HTMLInputElement>;
    @ViewChild('simulationlinkinput') inputCopy: ElementRef;
    @ViewChild('toggleButton') toggleButton: ElementRef;
    @ViewChild('toggleButton1') toggleButton1: ElementRef;
    @ViewChild('menu') menu: ElementRef;
    @ViewChild('matTooltipCopied') matTooltipCopied: MatTooltip;

    get selectedTypes() {
        const id = this.createOrUpdateModel.detailsRequest.simulationTypeId;
        if (id) {
            return this.listSimulationType?.find(type => type.id == id);
        }
    }

    get minDate() {
        // set minDate is today
        if (this.actionType === 'create') {
            return new Date();
        }
    }

    isMenuOpen = false;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: SimulationDialogData,
        public snackBar: MatSnackBar,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<AddSimulationFormComponent>,
        private renderer: Renderer2,
        private helperService: HelperService,
        private dateAdapter: DateAdapter<Date>,
        private organizationsService: OrganizationService,
        private simulationService: SimulationService,
        private translate: TranslateService,
        private validationService: ValidationService,
        private authService: AuthService,
    ) {
        this.listOrganization = data.organizations ?? [];

        this.renderer.listen('window', 'click', e => {
            if (
                e.target.className !== this.toggleButton?.nativeElement?.className &&
                e.target.className !== this.toggleButton1?.nativeElement?.className &&
                e.target.className !== this.menu?.nativeElement?.className &&
                ['minute-dots-second', 'line-time'].indexOf(e.target.className) == -1 &&
                ['ip-minute', 'ip-second', 'am', 'pm'].indexOf(e.target.id) == -1
            ) {
                this.isMenuOpen = false;
            }
        });
        this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
        this.createOrUpdateModel!.settingsRequest!.loginCode = this.helperService.makeid(5);
        this.createOrUpdateModel.createdBy = this.authService.userAttrs?.sub;
        //edit
        if (this.data?.simulation?.id) {
            //select simulation type
            const selectOrganization = this.listOrganization.find(
                org => org.id == this.data?.simulation?.organizationId,
            );
            if (selectOrganization) {
                this.listSimulationType = selectOrganization.simulateTypes ?? [];
            }
            const simulation = this.data.simulation;
            this.actionType = 'update';
            this.dateOfSimulation = simulation?.startDate ? new Date(simulation?.startDate) : new Date();
            this.createOrUpdateModel = {
                simulationId: simulation.id,
                actionType: 'update',
                detailsRequest: {
                    name: simulation.name,
                    startDate: simulation.startDate,
                    startTime: simulation.startTime,
                    organizationId: simulation.organizationId,
                    simulationTypeId: simulation.simulationTypeId,
                    roomNumber: simulation.roomNumber,
                    participantLogAvailable: simulation.participantLogAvailable,
                },
                settingsRequest: {
                    loginCode: simulation.loginCode,
                    link: simulation.link,
                    acceptJoinViaLink: simulation.acceptJoinViaLink,
                    resendEmail: true,
                    invitePeople: simulation.invitePeople
                        ? JSON.parse(simulation.invitePeople)?.map((item: any) => {
                              return {
                                  name: item.Name,
                                  avatar: item.Avatar,
                                  email: item.Email,
                              };
                          })
                        : [],
                },
            };
            this.minute = this.formatTime(this.dateOfSimulation.getHours());
            this.second = this.formatTime(this.dateOfSimulation.getMinutes());
            this.inputTime = `${this.minute}:${this.second}`;

            // console.log(dateUtc);

            // this.minute = this.createOrUpdateModel.detailsRequest?.startTime?.split(':')[0] || '';
            // this.second = this.createOrUpdateModel.detailsRequest?.startTime?.split(':')[1] || '';
            if (Number(this.minute) < 12) {
                this.activeAm = true;
                this.activePm = false;
            } else {
                this.activeAm = false;
                this.activePm = true;
            }
        }
    }

    formatTime(second: number): string {
        return second < 10 ? `0${second}` : `${second}`;
    }

    toggleSelectTime() {
        this.isMenuOpen = !this.isMenuOpen;
    }

    clickContinue() {
        this.myFormElement.control.markAllAsTouched();
        if (this.myFormElement.valid) {
            const date = new Date(this.myFormElement.value.startDate).getDate();
            const month = new Date(this.myFormElement.value.startDate).getMonth();
            const year = new Date(this.myFormElement.value.startDate).getFullYear();
            const currentDate = new Date().getDate();
            const currentMonth = new Date().getMonth();
            const currentYear = new Date().getFullYear();
            if (date === currentDate && month === currentMonth && year === currentYear) {
                if (new Date().getHours() >= Number(this.minute) && new Date().getMinutes() >= Number(this.second)) {
                    this.validateTime = true;
                    return;
                }
            }
            //trường hợp sửa
            if (this.createOrUpdateModel.simulationId) {
                this.activeTab = 2;
                this.lstTab = [1, 2];
            }
            //  trường hợp thêm mới
            else {
                const data = {
                    createdBy: this.createOrUpdateModel.createdBy,
                    detailsRequest: this.createOrUpdateModel.detailsRequest,
                };
                this.simulationService.createSimulationTemp(data).subscribe(result => {
                    if (result && result.data) {
                        (this.createOrUpdateModel.simulationId = result.data.id),
                            (this.createOrUpdateModel.settingsRequest.link = result.data.link);
                        this.inviteLink = `${this.createOrUpdateModel.settingsRequest.link}?code=${this.createOrUpdateModel.settingsRequest.loginCode}`;
                        this.activeTab = 2;
                        this.lstTab = [1, 2];
                    }
                });
            }
        }
    }

    clickBtnBack() {
        this.activeTab = 1;
        this.lstTab = [1];
    }

    clickUpdate(form1Param: NgForm) {
        //set tab 1 touched
        this.myFormElement.control.markAllAsTouched();

        if (
            form1Param.valid &&
            (this.createOrUpdateModel?.settingsRequest?.invitePeople?.length != 0 ||
                this.createOrUpdateModel.settingsRequest.acceptJoinViaLink)
        ) {
            this.createOrUpdateModel.actionType = 'update';
            this.createOrUpdateModel.detailsRequest.startDate = new Date(this.dateOfSimulation).getTime();
            this.createOrUpdateModel.settingsRequest.link = `${this.createOrUpdateModel.settingsRequest.link}?code=${this.createOrUpdateModel.settingsRequest.loginCode}`;
            //convert startDate and startTime to utc time
            const utc = new Date(
                `${this.dateOfSimulation.toDateString()} ${this.createOrUpdateModel.detailsRequest.startTime}`,
            );
            this.createOrUpdateModel.detailsRequest.startDate = utc.getTime();
            this.createOrUpdateModel.detailsRequest.startTime = `${utc.getUTCHours()}:${utc.getUTCMinutes() || '00'}`;
            this.simulationService.update(this.createOrUpdateModel).subscribe(result => {
                if (result && result.data) {
                    this.dialogRef.close('OK');
                    this.snackBar.openFromComponent(ToastSuccessfullyComponent, {
                        duration: 3000,
                        horizontalPosition: 'center',
                        verticalPosition: 'top',
                        panelClass: ['successfully-snackbar', 'd-flex', 'align-items-center'],
                        data: {
                            status: 'successfully',
                            text:
                                this.actionType == 'create'
                                    ? this.translate.instant('CreateOrUpdateSimulation.AddMessageSuccess')
                                    : this.translate.instant('CreateOrUpdateSimulation.UpdateMessageSuccess'),
                        },
                    });
                }
            });
        }
    }

    copySimulationLink(): void {
        navigator.clipboard.writeText(
            `${this.createOrUpdateModel.settingsRequest.link}?code=${this.createOrUpdateModel.settingsRequest.loginCode}`,
        );
        this.matTooltipCopied.disabled = false;
        this.matTooltipCopied.show();
        // inputElement.select();
        document.execCommand('copy');
        // inputElement.setSelectionRange(0, 0);
        // this.inputCopy.nativeElement.blur();
        setTimeout(() => {
            this.matTooltipCopied.disabled = true;
        }, 1000);
    }

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();

        // Add our fruit
        if (
            value &&
            !this.createOrUpdateModel?.settingsRequest?.invitePeople?.find(e => e.name == value) &&
            this.helperService.isValidEmail(value)
        ) {
            this.createOrUpdateModel?.settingsRequest?.invitePeople?.push({ email: value, avatar: '', name: '' });
        }

        // Clear the input value
        event.chipInput!.clear();

        this.peopleCtrl.setValue(null);
    }

    remove(people: string): void {
        const index = this.createOrUpdateModel?.settingsRequest?.invitePeople?.findIndex(i => i.email === people) || 0;

        if (index >= 0) {
            this.createOrUpdateModel?.settingsRequest?.invitePeople?.splice(index, 1);
        }
    }

    setTime() {
        this.validateTime = false;
        this.minute = this.minute.replace(/\s/g, '');
        this.second = this.second.replace(/\s/g, '');
        this.minute =
            !['0', ''].includes(this.minute) && !isNaN(Number(this.minute)) && this.minute ? this.minute : '00';
        this.second =
            !['0', ''].includes(this.second) && !isNaN(Number(this.second)) && this.second ? this.second : '00';

        // if (this.activePm && Number(this.minute) < 12 && Number(this.minute) > 0) {
        //     return (this.createOrUpdateModel.detailsRequest.startTime = `${Number(this.minute) + 12}:${this.second}`);
        // }
        this.inputTime = `${this.minute}:${this.second}`;

        return (this.createOrUpdateModel.detailsRequest.startTime = `${this.minute}:${this.second}`);
    }

    setMinute() {
        this.validateTime = false;
        if (this.minute.length > 2) {
            // Example: 1200 => 12
            this.minute = this.minute?.substring(0, 2);
        }
        if (Number(this.minute ?? '') < 10 && this.minute.length < 2) {
            this.minute = `0${this.minute}`;
        }
        if (Number(this.minute ?? '') > 23) {
            this.activePm ? (this.minute = '12') : (this.minute = '00');
        }
        if (Number(this.minute ?? '') < 0) {
            this.minute = '00';
        }
    }

    setSecond() {
        this.validateTime = false;
        if (this.second.length > 2) {
            // Example: 1200 => 12
            this.second = this.second?.substring(0, 2);
        }
        if (Number(this.second ?? '') < 10 && this.second.length < 2) {
            this.second = `0${this.second}`;
        }
        if (Number(this.second ?? '') < 0 || Number(this.second ?? '') > 59) {
            this.second = '00';
        }
    }

    // openAddSimulationTypeForm() {
    //     let modal = this.dialog.open(AddSimulationTypeFormComponent, {
    //         width: '470px',
    //         minHeight: '379px',
    //         panelClass: ['position-relative', 'xs-mobile-90'],
    //         autoFocus: false,
    //     });

    //     modal.afterClosed().subscribe(data => {
    //         if (data && data.id) {
    //             this.createOrUpdateModel.detailsRequest.simulationTypeId = data.id;
    //         }
    //     });
    // }

    onSimulationTypeChange(id: any) {
        const selected = this.listSimulationType?.find(type => type.id == id);
        if (selected) {
            this.myFormElement?.form?.controls['simulationTypeId']?.setValue(selected.id);
        }
    }

    onChangeOrg(id: number) {
        const selectedOrg = this.listOrganization.find(org => org.id == id);
        if (selectedOrg) {
            this.listSimulationType = selectedOrg.simulationTypes;
            const defaultType = selectedOrg.simulateTypes?.find((type: any) => type.isDefault);
            if (defaultType) {
                this.createOrUpdateModel.detailsRequest.simulationTypeId = defaultType.id;
            }
        }
    }

    getDataSourceOrganizations() {
        this.organizationsService.getAllOrganizations().subscribe(result => {
            if (result && result.data) {
                this.listOrganization = result.data;
            }
        });
    }

    onCloseModal() {
        const confirmCloseDialog = this.dialog.open(ConfirmCloseDialogComponent, {
            width: '400px',
            height: '250px',
            position: {
                top: '78px',
            },
            panelClass: 'position-relative',
        });

        confirmCloseDialog.afterClosed().subscribe(data => {
            if (data == 'OK') {
                this.dialogRef.close();
            }
        });
    }

    validatorLogAvailable: any = (c: any) => {
        return this.validationService.logAvailable(c);
    };
}
